import React from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { ActionValue } from '~/models/Auth/AuthParamModel';
import AuthContent from '../components/AuthContent';
import withStyles from '@material-ui/core/styles/withStyles';
import { BORDER_COLOR } from '../../core/styles/variables';

const Wrapper = withStyles((theme) => ({
  root: {
    borderRadius: theme.shape.borderRadius,
    maxWidth: theme.breakpoints.values.sm,
    margin: theme.spacing(10, 'auto'),
    padding: theme.spacing(4),
    border: `1px solid ${BORDER_COLOR}`,
    [theme.breakpoints.down('xs')]: {
      border: 'none',
      padding: theme.spacing(0),
      margin: theme.spacing(5, 'auto'),
    },
  },
}))(Grid);

interface Props {
  errorType?: string;
  action?: ActionValue;
  businessId?: number;
  planId?: number;
  universityInvitationCode?: string;
}

const Login = ({
  errorType,
  action,
  businessId,
  planId,
  universityInvitationCode,
}: Props) => {
  // 各値が存在するときだけkey, valueを定義する
  const authParams = {
    ...(action && { action }),
    ...(businessId && { businessId }),
    ...(planId && { planId }),
    ...(universityInvitationCode && { universityInvitationCode }),
  };

  return (
    <Container maxWidth="lg">
      <Wrapper container direction="column" justify="center">
        <AuthContent errorType={errorType} authParams={authParams} />
      </Wrapper>
    </Container>
  );
};

export default Login;
